import { render } from "./BaseConfirmField.vue?vue&type=template&id=c8f923d2"
import script from "./BaseConfirmField.vue?vue&type=script&lang=js"
export * from "./BaseConfirmField.vue?vue&type=script&lang=js"

import "./BaseConfirmField.vue?vue&type=style&index=0&id=c8f923d2&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__